import React, { useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody } from "reactstrap";
import { Button } from "react-bootstrap";
import { useHistory, Link } from "react-router-dom";
import { HiOutlineTrash } from "react-icons/hi";
import { FiEdit2 } from "react-icons/fi";
import axios, { get } from "axios";
import { ToastContainer, toast } from "react-toastify";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import config from "../../../../config";
import Breadcrumbs from "../../../Helper/Breadcrumbs";

const CategoryTable = () => {
  const history = useHistory();
  const tokenKey = {
    headers: { Authorization: "Token " + sessionStorage.getItem("tokenKey") },
  };
  let breadcrumbData = [
    { title: "seobook", href: "/seobook" },
    { title: "Blog Caterory", href: "#" },
  ];
  const toastAttr = {
    theme: "colored",
    position: "top-center",
    autoClose: 1000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    get(config.service + "/masters/blog-categories/", tokenKey)
      .then((res) => setTableData(res.data))
      .catch((err) => {
        if (err.response?.status === 401) window.location.href = "/";
      });
  }, []);

  const deleteRow = (row) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      axios
        .delete(
          config.service + "/masters/blog-categories/" + row.id + "/",
          tokenKey
        )
        .then(() => {
          get(config.service + "/masters/blog-categories/", tokenKey).then(
            (res) => {
              setTableData(res.data);
            }
          );
        })
        .catch((err) => toast.error("Deletion Failed", toastAttr));
    }
  };

  const renderForm = (row) => {
    history.push({
      pathname: "/seobook/blogCategoryform",
      state: row ? { id: row.id, editMode: true } : {},
    });
  };

  const cols = [
    {
      dataField: "name",
      text: "Category Name",
      headerStyle: { width: "250px" },
    },
    {
      dataField: "description",
      text: "Description",
      headerStyle: { width: "400px" },
      formatter: (cell) => <div style={{ maxWidth: "400px" }}>{cell}</div>,
    },
    {
      dataField: "id",
      text: "Actions",
      headerStyle: { width: "120px" },
      formatter: (cell, row) => (
        <div className="tableActions">
          <FiEdit2 title="Edit" onClick={() => renderForm(row)} />
          <HiOutlineTrash title="Delete" onClick={() => deleteRow(row)} />
        </div>
      ),
    },
  ];

  const rowEvents = {
    onClick: (e, row) => renderForm(row),
  };

  const options = paginationFactory({
    sizePerPage: 20,
    paginationSize: 3,
    hideSizePerPage: true,
    totalSize: tableData.length,
    hidePageListOnlyOnePage: true,
  });

  return (
    <Container>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <div className="card__title pageNav">
                <div className="bold-text">
                  <Breadcrumbs data={breadcrumbData} />
                </div>
              </div>
              <div className="formBtnsDiv mb-3">
                <Button variant="primary" onClick={() => renderForm()}>
                  Create Category
                </Button>
              </div>
              <BootstrapTable
                bootstrap4
                wrapperClasses="table-responsive"
                keyField="id"
                data={tableData}
                columns={cols}
                rowEvents={rowEvents}
                hover
                noDataIndication="No categories found"
                pagination={options}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <ToastContainer {...toastAttr} />
    </Container>
  );
};

export default CategoryTable;
